import script from "./LoaderOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/modules/LoaderOverlay.css?vue&type=style&index=0&id=edd9b508&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edd9b508"]])

export default __exports__